import React, { useContext } from 'react';

const SuggestionsContext = React.createContext({});

const SuggestionsProvider = props => (
  <SuggestionsContext.Provider
    {...props}
  />
);

export const useSuggestions = () => {
  const context = useContext(SuggestionsContext);

  if (context === undefined) {
    throw new Error("useSuggestions must be used within a SuggestionsProvider");
  }

  return context;
};

export default SuggestionsProvider;
